// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowsRepeat16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrows-repeat': IconArrowsRepeat;
    }
}

/**
 * The icon component for the 'arrowsRepeat' icon
 */
export class IconArrowsRepeat extends Icon {
    public constructor() {
        super(arrowsRepeat16X16);
    }
}

registerIcon('icon-arrows-repeat', IconArrowsRepeat);
export const iconArrowsRepeatTag = 'nimble-icon-arrows-repeat';
